import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { BeneficiaryRegistrationGetOTP as BENE_GET_OTP } from 'Components/Api/WhiteLabelPaytmCCFDMTApi';
import { ViewBeneficiary as BENE_SELECT } from 'Components/Api/WhiteLabelPaytmCCFDMTApi';
import { Select as BANK_SELECT } from 'Components/Api/DMTBankAPI';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MoneyTransfer as DMT_TRANSFER } from 'Components/Api/WhiteLabelPaytmCCFDMTApi';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    PLEASE_PROVIDE_VALID,
    PLEASE_SELECT_VALID
} from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';

const CustomContainer = HOCLoader(Container);

export const BeneficiaryVerify = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [mainColumns, setMainColumns] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bankList, setBankList] = useState([]);
    const [list, setList] = useState([]);
    const [severity, setSeverity] = useState('success');
    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        DefaultIFSC: ''
    });
    const location = useLocation();
    const Mobile = location.state.Mobile;
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        Name: '',
        BankName: bankDefault,
        AccountNo: '',
        IFSC: '',
        OTP: '',
        BeneficiaryID: '',
        isAddOnly: false
    });

    useEffect(() => {
        selectBank();
        selectBene();
        select();
        createColumns();
    }, []);

    const selectBank = async () => {
        setLoading(true);
        const response = await BANK_SELECT();
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const select = async () => {
        setLoading(false);
        if (Mobile === undefined) {
            return;
        }

        setFormObject({
            ...formObject,
            Mobile: Mobile
        });
    };

    const selectBene = async () => {
        setLoading(true);
        setIsError(false);
        let senderNo = Mobile;
        if (senderNo === undefined) return;

        if (senderNo === '') return;

        var beneReqObj = JSON.stringify({ Mobile: Mobile });

        var response = await BENE_SELECT(beneReqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);
        setList(data);
    };

    const submithandle = async (request, { setSubmitting, resetForm }) => {
        if (request.isAddOnly === true) {
            core_bene_verify(request, request.Name);
            return;
        }

        let jsonObj = {
            Mobile: request.Mobile,
            Name: request.Name,
            BankName: request.Bank.Name,
            AccountNo: request.AccountNo,
            IFSC: request.IFSC,
            BeneficiaryID: request.Mobile,
            SenderID: request.Mobile,
            Amount: 1,
            PaymentType: 'IMPS',
            RechargePin: '',
            Through: 'WEB',
            IsVerify: true
        };
        setIsError(false);
        setLoading(true);

        var apirequest = JSON.stringify(jsonObj);

        var response = await DMT_TRANSFER(apirequest);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        if (!response.status) {
            var dataError = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(dataError.Message);

            setIsError(true);
            return;
        }

        setSeverity('success');
        var data = JSON.parse(response.data);

        setResponseMessage(data.Message);
        setIsError(true);

        if (data.Status === 'FAILURE') {
            setSeverity('error');
            return;
        }

        setFormObject({
            ...formObject,
            Mobile: request.Mobile,
            Name: data.BeneficiaryName,
            Bank: request.Bank.Name,
            AccountNo: request.AccountNo,
            ConfirmAccountNo: request.AccountNo,
            IFSC: request.IFSC,
            SenderID: request.Mobile
        });

        if (loading) {
            setLoading(false);
            return;
        }

        //var res = data.Message.split(', Name:', 2);
        var beneName = data.BeneficiaryName;
        core_bene_verify(request, beneName);
    };

    const core_bene_verify = async (request, beneName) => {
        var requestOTP = {
            Mobile: request.Mobile,
            AccountNo: request.AccountNo
        };

        var requestObj = JSON.stringify(requestOTP);

        setLoading(true);
        setIsError(false);

        var verifyResponse = await BENE_GET_OTP(requestObj);
        setLoading(false);
        if (!verifyResponse.isAuthorized) LOGOUT();

        if (!verifyResponse.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(verifyResponse.data);

            return;
        }

        let dataOTP = JSON.parse(verifyResponse.data);

        setIsError(true);
        setResponseMessage(dataOTP.Message);
        setSeverity('success');

        var param = {
            State: dataOTP.State,
            Name: beneName,
            Mobile: request.Mobile,
            AccountNo: request.AccountNo,
            BankName: request.Bank.Name,
            IFSC: request.IFSC
        };

        history.push('/WPC_BeneficiaryAdd', param);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'BeneficiaryID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'Name'
        });
        columns.push({
            label: 'Bank',
            name: 'BankName'
        });
        columns.push({
            label: 'AccountNo',
            name: 'AccountNo'
        });

        columns.push({
            label: 'IFSC',
            name: 'IFSC'
        });

        setMainColumns(columns);
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        Name: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        Bank: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'bank')
            .required(PLEASE_SELECT_VALID + 'bank')
            .shape({
                Name: Yup.string()
                    .nullable(PLEASE_SELECT_VALID + 'bank')
                    .required(PLEASE_SELECT_VALID + 'bank')
            }),
        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        ConfirmAccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'confirm account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no')
            .oneOf([Yup.ref('AccountNo'), null], "AccountNo don't match"),

        IFSC: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSC')
            .length(11, PLEASE_PROVIDE_VALID + 'IFSC')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        Beneficiary Verify
                                    </h2>

                                    <Paper className={classes.PaperStyle}>
                                        <Grid container spacing={2}>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <Field
                                                    component={
                                                        AutoCompleteTextView
                                                    }
                                                    defaultValue={bankDefault}
                                                    SubFieldName="Name"
                                                    FieldName="Bank"
                                                    name="Bank"
                                                    onCustomCallback={(
                                                        name,
                                                        value
                                                    ) => {
                                                        setFieldValue(
                                                            'IFSC',
                                                            value.DefaultIFSC
                                                        );
                                                        setBankDefault({
                                                            DefaultIFSC:
                                                                value.DefaultIFSC,
                                                            Name: value.Name
                                                        });
                                                    }}
                                                    options={bankList}
                                                    getOptionLabel={(option) =>
                                                        option.Name
                                                    }
                                                    getOptionSelected={(
                                                        option,
                                                        value
                                                    ) =>
                                                        option.Name ===
                                                        value.Name
                                                    }
                                                    textFieldProps={{
                                                        label: 'Bank'
                                                    }}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialTextField
                                                    label="IFSC"
                                                    name="IFSC"
                                                    type="text"
                                                    length={11}
                                                    placeholder="IFSC"
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialNumberField
                                                    label="Account No."
                                                    name="AccountNo"
                                                    type="password"
                                                    length={20}
                                                    placeholder="Account No."
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialNumberField
                                                    label="Confirm Account No."
                                                    name="ConfirmAccountNo"
                                                    type="text"
                                                    length={20}
                                                    placeholder="Confirm Account No."
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialTextField
                                                    label="Bene Name"
                                                    name="Name"
                                                    type="text"
                                                    placeholder="Bene Name"
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                            >
                                                <MaterialTextField
                                                    label="Mobile"
                                                    name="Mobile"
                                                    type="text"
                                                    readOnly={true}
                                                    placeholder="Mobile"
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                                style={{ marginLeft: '10px' }}
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Verify"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            true
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                    disabled={loading}
                                                >
                                                    Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Verify"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    onClick={(e) => {
                                                        setFieldValue(
                                                            'isAddOnly',
                                                            false
                                                        );
                                                        handleSubmit(e);
                                                    }}
                                                    disabled={loading}
                                                >
                                                    Verify & Add
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>

                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </CustomContainer>
    );
};
